import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Users, ArrowRight, AlertTriangle, MapPin } from 'lucide-react';

const MoveAllConfirmationModal = ({
  isOpen,
  onClose,
  horses,
  currentZone,
  targetZone,
  onConfirm
}) => {
  if (!horses || !currentZone || !targetZone) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-600" />
            Confirmer le déplacement
          </DialogTitle>
          <DialogDescription>
            d'une zone à une autre.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          {/* Informations des chevaux */}
          <Card className="bg-blue-50 border-blue-200">
            <CardContent className="p-4 flex items-center gap-3">
              <div className="bg-blue-100 p-2 rounded-full">
                <Users className="h-5 w-5 text-blue-600" />
              </div>
              <div><p className="text-sm text-gray-600">
                  De {currentZone.name} vers {targetZone.name}
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Liste des chevaux (optionnel, tu peux la retirer si trop longue) */}
          <div className="max-h-40 overflow-y-auto bg-white border rounded p-2">
            {horses.map(h => (
              <div key={h.id} className="text-sm text-gray-800 py-1">
                {h.nom || "—"} <span className="text-xs text-gray-500">({h.sire || ''})</span>
              </div>
            ))}
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-3 pt-4 border-t">
            <Button variant="outline" onClick={onClose}>
              Annuler
            </Button>
            <Button 
              onClick={onConfirm}
              className="flex items-center gap-2"
            >
              <ArrowRight className="h-4 w-4" />
              Confirmer le déplacement
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MoveAllConfirmationModal;
